// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-mobile-header-user-panel__user {
  align-items: center;
  display: flex;
  padding: var(--g-spacing-3) var(--g-spacing-2);
}
.dl-mobile-header-user-panel__user-info {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-short-font-size);
  line-height: var(--g-text-body-short-line-height);
  display: flex;
  flex: auto;
  flex-direction: column;
  min-width: 0;
  margin-left: var(--g-spacing-3);
}
.dl-mobile-header-user-panel__user-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-mobile-header-user-panel__user-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--g-color-text-secondary);
}
.dl-mobile-header-user-panel__user-avatar {
  flex-shrink: 0;
}
.dl-mobile-header-user-panel .dl-mobile-header-user-panel__menu-item {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
  padding: var(--g-spacing-3) var(--g-spacing-5);
}
.dl-mobile-header-user-panel__menu-icon {
  color: var(--gn-aside-header-item-icon-color);
  margin-right: var(--g-spacing-4);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MobileHeader/MobileHeaderComponent/UserPanel/UserPanel.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAGI;EACI,mBAAA;EACA,aAAA;EACA,8CAAA;AAFR;AAKI;ECmLA,2CAAA;EACA,2CAAA;EACA,6CAAA;EACA,iDAAA;EDpLI,aAAA;EACA,UAAA;EACA,sBAAA;EACA,YAAA;EACA,+BAAA;AAAR;AAGI;ECdA,mBAAA;EACA,gBAAA;EACA,uBAH4B;ADiBhC;AAEI;EClBA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDqBxB,oCAAA;AAER;AACI;EACI,cAAA;AACR;AAEI;EC+IA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;EDhJI,8CAAA;AAGR;AAAI;EACI,6CAAA;EACA,gCAAA;AAER","sourcesContent":[".dl-mobile-header-user-panel__user {\n  align-items: center;\n  display: flex;\n  padding: var(--g-spacing-3) var(--g-spacing-2);\n}\n.dl-mobile-header-user-panel__user-info {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-short-font-size);\n  line-height: var(--g-text-body-short-line-height);\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  min-width: 0;\n  margin-left: var(--g-spacing-3);\n}\n.dl-mobile-header-user-panel__user-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-mobile-header-user-panel__user-description {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--g-color-text-secondary);\n}\n.dl-mobile-header-user-panel__user-avatar {\n  flex-shrink: 0;\n}\n.dl-mobile-header-user-panel .dl-mobile-header-user-panel__menu-item {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n  padding: var(--g-spacing-3) var(--g-spacing-5);\n}\n.dl-mobile-header-user-panel__menu-icon {\n  color: var(--gn-aside-header-item-icon-color);\n  margin-right: var(--g-spacing-4);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
